var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddressStaticMap',{attrs:{"map-img":_vm.mapImg,"title":_vm.title,"address":_vm.address,"lng":_vm.lng,"lat":_vm.lat}})
}
var staticRenderFns = []

export { render, staticRenderFns }